// extracted by mini-css-extract-plugin
export default {"title":"TagFilter_title__ffOcZ","tags":"TagFilter_tags__JsM4N","tag":"TagFilter_tag__YGFy7","active":"TagFilter_active__GEa9d","container":"TagFilter_container__xZ9kK"};